'use strict';

var React = require('react');
//Components
var PersonalInfo = require('./PersonalInfo.jsx');
var ContactDetails = require('./ContactDetails.jsx');
var Address = require('./Address.jsx');

var CompanyInvestor = React.createClass({
    render: function () {
        return (
                <div>
                    <PersonalInfo index={this.props.index}
                                  data={this.props.data}
                                  titleList={this.props.titleList}
                                  section="ydInvestor"
                                  errorList={this.props.errorList}
                                  isFullNameMessageHidden={true} />
                    <Address index={this.props.index}
                             data={this.props.data.addressInfo}
                             withPostalAddress={false}
                             section="ydInvestor"
                             errorList={this.props.errorList}                             
                             productId={this.props.productId} />
                    <ContactDetails index={this.props.index}
                                    productId={this.props.productId}
                                    accountType={this.props.accountType}
                                    data={this.props.data}
                                    errorList={this.props.errorList} 
                                    section="ydInvestor"/>
                </div>

        );
    }
});

module.exports = CompanyInvestor;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/CompanyInvestor.jsx